import { defineStore } from 'pinia';
import { ref } from 'vue';
import { CourseDetail } from '../models/course-detail';
import { PackageIncludedProduct } from '../models/included-product';
import { Package } from '../models/package';
import { lookupService } from '../services/lookup.service';

export const useCoursesRequireDobStore = defineStore('courses-require-dob', () => {
  /** @type {import('vue').Ref<CourseDetail[] | null>} */
  const coursesRequiredDob = ref([]);

  /** Get course required dob. */
  async function getCoursesRequiredDob() {
    coursesRequiredDob.value = await lookupService.getCourses({ isRequiredDob: true });
  }

  /**
   * Check if project is require DOB.
   * @param {PackageIncludedProduct} product Product
   * @returns {boolean}
   */
  function isProductRequireDob(product) {
    return coursesRequiredDob.value.find(course => course.id === product.id) != null;
  }

  /**
   * Check if package require DOB.
   * @param {Package} packageToCheck Package to check.
   * @returns {boolean}
   */
  function isPackageRequireDob(packageToCheck) {
    return packageToCheck.includedProducts
      .find(product => isProductRequireDob(product)) != null;
  }

  /**
   * Check if course require DOB.
   * @param {CourseDetail} courseToCheck Course to check.
   * @returns {boolean}
   */
  function isCourseRequireDob(courseToCheck) {
    return coursesRequiredDob.value.find(course => course?.id === courseToCheck?.id) != null;
  }

  return {
    // Variables
    coursesRequiredDob,

    // Functions
    getCoursesRequiredDob,
    isCourseRequireDob,
    isPackageRequireDob,
  };
});
